import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { TargetAudienceSection } from '../components/sections/TargetAudienceSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { CourseContentSection } from '../components/sections/CourseContentSection';
import { CourseFeaturesSection } from '../components/sections/CourseFeaturesSection';
import { PricingSection } from '../components/sections/PricingSection';
import { BonusesSection } from '../components/sections/BonusesSection';
import { SecuritySection } from '../components/sections/SecuritySection';
import { AboutSection } from '../components/sections/AboutSection';
import { VideoGallerySection } from '../components/sections/VideoGallerySection';
import { FAQSection } from '../components/sections/FAQSection';
import { StickyCTA } from '../components/StickyCTA';
import { LivePurchaseNotification } from '../components/LivePurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-slate-950 font-sans selection:bg-blue-900 selection:text-blue-200" data-id="element-200">
      <HeroSection data-id="element-201" />
      <TargetAudienceSection data-id="element-202" />
      <TestimonialsSection data-id="element-203" />
      <CourseContentSection data-id="element-204" />
      <CourseFeaturesSection data-id="element-205" />
      <PricingSection data-id="element-206" />
      <BonusesSection data-id="element-207" />
      <SecuritySection data-id="element-208" />
      <AboutSection data-id="element-209" />
      <VideoGallerySection data-id="element-210" />
      <FAQSection data-id="element-211" />

      {/* Footer minimalista */}
      <footer className="bg-black py-8 text-center text-slate-500 text-sm px-4" data-id="element-212">
        <p data-id="element-213">
          © {new Date().getFullYear()} Bruno. Todos los derechos reservados.
        </p>
        <p className="mt-2" data-id="element-214">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </footer>

      <StickyCTA data-id="element-215" />
      <LivePurchaseNotification data-id="element-216" />
    </div>;
}